/**
 * O SDK do Chatwoot não é idempotente: cada `chatwootSDK.run()` adiciona outra instância do widget.
 * React Strict Mode executa efeitos duas vezes em dev; sem este guard, o chat abre duplicado.
 *
 * A flag só permanece se `run()` não lançar — falha permite retry no próximo effect.
 */
declare global {
  interface Window {
    __astra_chatwoot_sdk_run_invoked?: boolean
  }
}

export function resetChatwootSdkRunGuard(): void {
  if (typeof window === "undefined") return
  if ((window as Window & { $chatwoot?: unknown }).$chatwoot) return
  window.__astra_chatwoot_sdk_run_invoked = false
}

export function runChatwootSdkOnce(opts: { websiteToken: string; baseUrl: string }): boolean {
  if (typeof window === "undefined") return false
  const w = window as Window & {
    $chatwoot?: unknown
    chatwootSDK?: { run: (o: { baseUrl: string; websiteToken: string }) => void }
  }
  if (w.$chatwoot) return true
  if (!w.chatwootSDK) return false
  if (window.__astra_chatwoot_sdk_run_invoked) return false

  window.__astra_chatwoot_sdk_run_invoked = true
  try {
    w.chatwootSDK.run(opts)
    return true
  } catch (err) {
    window.__astra_chatwoot_sdk_run_invoked = false
    if (process.env.NODE_ENV !== "production") {
      console.warn("[chatwoot] chatwootSDK.run() falhou; retry permitido.", err)
    }
    return false
  }
}
